import {
  API_ADMIN_CARDS_VIRTUAL,
  API_ADMIN_FEES,
  API_ADMIN_GET_ADMIN_BALANCE,
  API_ADMIN_GET_BALANCE,
  API_ADMIN_INFO,
  API_ADMIN_WALLET,
  API_ADMIN_WALLET_EDIT,
  API_LIST,
  API_PARTNER_CREATE,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";

export const getAdminWalletAPI = (adminId) => {
  let postData = {
    admin_id: adminId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_WALLET,
    data: postData,
  });
};

export const getAdminFeesListAPI = (adminId) => {
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_FEES,
    data: {
      adminId,
    },
  });
};

export const getAdminInfoAPI = ({ adminId }) => {
  let postData = {
    adminId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_INFO,
    data: postData,
  });
};

export const getAdminBalanceAPI = (walletId) => {
  let postData = {
    wallet_id: walletId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_GET_BALANCE,
    data: postData,
  });
};

export const getSuperAdminBalanceAPI = (walletId) => {
  let postData = {
    wallet_id: walletId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_GET_ADMIN_BALANCE,
    data: postData,
  });
};

export const editAdminWalletMinimumBalanceAPI = ({ walletId, minBalance }) => {
  let postData = {
    walletId,
    minBalance,
  };
  return axiosMiddleware({
    method: "post",
    url: API_ADMIN_WALLET_EDIT,
    data: postData,
  });
};

export const getAdminsListAPI = () => {
  return axiosMiddleware({
    method: "post",
    url: API_LIST,
  });
};

export const getAdminVirtualCardAPI = ({ adminId, limit, offset }) => {
  let postData = {
    adminId: adminId,
  };
  return axiosMiddleware({
    method: "get",
    url: `/${API_ADMIN_CARDS_VIRTUAL}?limit=${limit}&offset=${offset}`,
    data: postData,
  });
};
export const getAdminAgentDataAPI = ({ adminId }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_PARTNER_CREATE}/${adminId}`,
  });
};
